import { render, staticRenderFns } from "./GoodTableColumnSearch.vue?vue&type=template&id=679e904c"
import script from "./GoodTableColumnSearch.vue?vue&type=script&lang=js"
export * from "./GoodTableColumnSearch.vue?vue&type=script&lang=js"
import style0 from "./GoodTableColumnSearch.vue?vue&type=style&index=0&id=679e904c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports